import { render, staticRenderFns } from "./StartupReview.vue?vue&type=template&id=75a2858e&scoped=true&"
import script from "./StartupReview.vue?vue&type=script&setup=true&lang=js&"
export * from "./StartupReview.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a2858e",
  null
  
)

export default component.exports